import React from 'react';
import styles from "./CadastroFeito.css";
import Header from "../../components/features/login/Header";
import TitleModule from '../../components/features/register/TitleModule';
import RegisterProgress from '../../components/features/register/RegisterProgress';
import InstituicaoForm from '../../components/Cadastro-Feito/InstituicaoForm';

const CadastroFeito = () => {
    return (
      <div className="CadastroFeito-Page"> 
        <Header/>
        <div className={styles.container}>
            <TitleModule/>
            <RegisterProgress step={6} title="Cadastre a instituição" icon="apartment"/>
            <InstituicaoForm/>
        </div>
      </div>
    );
  };
  
  export default CadastroFeito;
  